import { ProfileBlockApi } from 'api/ApiHelper';
import { profileBlockQueryKey } from 'queries/profileBlock/queryKey';
import { useQuery } from '@tanstack/react-query';

export const useGetBlockProfileQuery = (profileId: number, enabled = false) =>
  useQuery({
    queryKey: profileBlockQueryKey.profileBlock(profileId),
    queryFn: () => ProfileBlockApi.getBlockProfile(profileId),
    enabled,
  });
